<template>
    <div> 
        <slot name="trigger" :open="open"></slot>
        <portal to="modal" v-if="modalOpen">
            <div @keydown="checkKeyEvent" @keydown.esc="close()" ref="modalContainer" role="dialog" :aria-hidden="this.open ? 'false' : 'true'" class="modal">
                <button 
                    class="btn btn_light modal-close" 
                    @click="close"
                    v-focus
                    aria-label="close"
                    >
                    <span class="isVisuallyHidden">Close</span>
                    <i class="icon icon_closingX icon_closingX_large"></i>     
                </button>
                <div class="modal-inner">
                  <slot name="modal-content"></slot>
                </div>
            </div>
        </portal>
    </div>
</template>

<script>
import { closest } from "../../utilities/closest.js";
import FocusTrap from '../mixins/FocusTrap';

export default {
  data() {
    return {
      initialFocus: null,
      modalOpen: false,
      storedY: null,
      modalContainer: null,
      modalClose: null
    };
  },
  mixins: [FocusTrap],
  methods: {
    handleKeyDown(event) {
      if (event.keycode == 27) {
        this.close()
        return;
      }
      this.checkKeyEvent();
    },
    open(event) {
      this.initialFocus = event.target;
      this.modalOpen = true;
      this.fixBody();
    },
    close() {
      this.modalOpen = false;
      this.freeBody();
      this.initialFocus.focus();
    },
    fixBody() {
      this.storedY = window.scrollY;
      document.documentElement.setAttribute(
        "style",
        `position: fixed; top: ${-1 *
          window.scrollY}px; height: 100%; width: 100%; overflow-y: scroll;`
      );
    },
    freeBody() {
      document.documentElement.setAttribute(
        "style",
        `position: relative; overflow-y: scroll;`
      );
      window.scroll(0, this.storedY);
    },
   },
  mounted() {
    window.addEventListener("scroll", this.getWindowOffset);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.getWindowOffset);
  }
};
</script>

<style lang="scss">
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 200;
  overflow-y: auto;
  // opacity: 0;
  // animation: fadeIn 500ms forwards;
}
// @keyframes fadeIn {
//   to {
//     opacity: 1;
//   }
// }

.modal-inner {
  width: 100%;
  height: 100%;
  position:relative;
  @media (max-height: 375px) and (min-width: 812px) {/*  IPhone X */
    height: auto;
  }
}

.modal-inner > div {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 85%;
  @media (max-height: 360px) and (min-width: 740px) {/* Galaxy s7 and s8 */
    width: 80%;
  }
  @media (max-height: 375px) and (min-width: 812px) {/*  IPhone X */
    width: 80%;
  }
}

.modal-inner .video {
  width: 100%;
  // border: 10px solid white;
  // border-radius: 5px;
  box-sizing: border-box;
}
.modal-close {
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  color: inherit;
  text-decoration: inherit;
  text-align: center;
  font-size: inherit;
  font-family: inherit;
  cursor: pointer;
  /* BTN reset ^ */

  position: fixed;
  top: 20px;
  left: 20px;
  background: transparent;
  z-index: 300;

  &:hover {
    background-color: transparent;
  }
   @media (max-width: 812px) {
     transform: scale(.75)
   }
}
</style>


